import expectedQualityRow from './expectedQuality/expectedQuality';
import { Row } from './shared';

export const rows: Row[] = [
  expectedQualityRow,
];
